import { render, staticRenderFns } from "./AgreeMent.vue?vue&type=template&id=6a5d9417&scoped=true"
var script = {}
import style0 from "./AgreeMent.vue?vue&type=style&index=0&id=6a5d9417&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d9417",
  null
  
)

export default component.exports